export const TASK_REGISTERED = 'task:registered';
export const TASK_UNREGISTERED = 'task:unregistered';
